import { isEmpty } from './is-empty.js';

export function isNotEmpty(value: string) {
  return !isEmpty(value);
}
